import { render, staticRenderFns } from "./EfsMdDiseaseModal__Style#Drawer.vue?vue&type=template&id=3b34b225&scoped=true&"
import script from "./EfsMdDiseaseModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./EfsMdDiseaseModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./EfsMdDiseaseModal__Style#Drawer.vue?vue&type=style&index=0&id=3b34b225&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34b225",
  null
  
)

export default component.exports